import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize20 {
  size?: '20';
}
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize20 | OverrideIconSize24;

const SvgComponent = ({
  size = '20',
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '20') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.24305 10.0532L5.15092 11.1453C3.97752 12.3187 3.97752 14.2212 5.15092 15.3946C6.32432 16.568 8.22677 16.568 9.40017 15.3946L16.284 8.51076C16.4793 8.3155 16.7958 8.3155 16.9911 8.51076C17.1864 8.70602 17.1864 9.0226 16.9911 9.21787L10.1073 16.1017C8.54336 17.6656 6.00774 17.6656 4.44382 16.1017C2.87989 14.5378 2.87989 12.0022 4.44381 10.4382L11.3276 3.5544C11.3311 3.55095 11.3346 3.54756 11.3381 3.54423C12.4466 2.44673 14.2349 2.45013 15.3392 3.55442C16.4469 4.66213 16.4469 6.45807 15.3392 7.56577L9.5568 13.3482C9.55534 13.3496 9.55388 13.3511 9.55242 13.3525C8.90059 13.9997 7.84755 13.9983 7.1975 13.3482C6.54601 12.6967 6.54601 11.6405 7.1975 10.989L12.4292 5.75729C12.6245 5.56202 12.941 5.56202 13.1363 5.75729C13.3316 5.95255 13.3316 6.26913 13.1363 6.46439L7.9046 11.6961C7.64365 11.9571 7.64365 12.3802 7.9046 12.6411C8.16556 12.9021 8.58866 12.9021 8.84961 12.6411L14.0813 7.4094C14.0825 7.40818 14.0838 7.40697 14.085 7.40576L14.6321 6.85866C15.3493 6.14148 15.3493 4.97871 14.6321 4.26153C13.9149 3.54435 12.7522 3.54435 12.035 4.26153L6.25256 10.0439C6.24942 10.0471 6.24625 10.0502 6.24305 10.0532Z"
          fill={color}
        />
      </svg>
    );
  }
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3361 4.3361C17.0459 3.04591 14.9541 3.04591 13.6639 4.3361L6.72501 11.275C6.72462 11.2754 6.72423 11.2758 6.72384 11.2762L5.40331 12.5967C3.56566 14.4343 3.56566 17.4138 5.40331 19.2514C7.24097 21.0891 10.2204 21.0891 12.058 19.2514L20.3186 10.9908C20.5139 10.7956 20.5139 10.479 20.3186 10.2837C20.1234 10.0885 19.8068 10.0885 19.6115 10.2837L11.3509 18.5443C9.90381 19.9914 7.55755 19.9914 6.11042 18.5443C4.66329 17.0972 4.66329 14.7509 6.11042 13.3038L14.371 5.04321C14.3714 5.04286 14.3717 5.04251 14.3721 5.04215C15.2718 4.14354 16.7297 4.14389 17.629 5.0432C18.5287 5.94287 18.5287 7.40151 17.629 8.30118L10.6901 15.2401C10.6895 15.2407 10.6889 15.2412 10.6884 15.2418C10.336 15.5923 9.76629 15.5917 9.41467 15.2401C9.06247 14.8879 9.06247 14.3168 9.41467 13.9646L15.6927 7.68659C15.888 7.49133 15.888 7.17475 15.6927 6.97948C15.4975 6.78422 15.1809 6.78422 14.9856 6.97948L8.70756 13.2575C7.96484 14.0003 7.96484 15.2045 8.70756 15.9472C9.45029 16.6899 10.6545 16.6899 11.3972 15.9472L17.6753 9.66913C17.676 9.66842 17.6767 9.6677 17.6774 9.66698L18.3361 9.00829C19.6263 7.7181 19.6263 5.62629 18.3361 4.3361Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 20, 24 입니다.
 *
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'attachment');
export default IconComponent;
